import { createSelector } from 'reselect';

import type { AppState } from '../../store/types';

const getSavedSearches = (state: AppState) =>
  state.savedSearchesReducer.savedSearches;

const getSavedSearchesQuery = (state: AppState) =>
  state.savedSearchesReducer.savedSearchesQuery;

const getGroups = (state: AppState) => state.savedSearchGroups.groups;

const getGroupsSorted = (state: AppState) =>
  state.savedSearchGroups.groupsSorted;

export const selectSavedSearchesAndGroups = createSelector(
  [getSavedSearches, getSavedSearchesQuery, getGroups, getGroupsSorted],
  (savedSearches, savedSearchesQuery, groups, groupsSorted) => {
    const resultGroups = savedSearchesQuery ? groupsSorted : groups;
    return resultGroups.concat(savedSearches);
  },
);
